import { Component, Input } from '@angular/core';

import { ColorUtils } from '../../app/shared/utils/color.utils';
import { UrlUtils } from '../url.utils';

@Component({
    selector: 'app-show-avatar',
    templateUrl: './show-avatar.component.html',
    styleUrls: ['./show-avatar.component.scss'],
    imports: []
})
export class ShowAvatarComponent {
    @Input() imageUrl: string | null | undefined = null;
    @Input() showName: string = '';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    get fullImageUrl(): string | null {
        return UrlUtils.getFullImageUrl(this.imageUrl);
    }

    get avatarStyle(): { initials: string; backgroundColor: string; textColor: string } {
        return ColorUtils.getAvatarStyle(this.showName);
    }

    get hasImage(): boolean {
        return !!this.imageUrl;
    }
}
